"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Image = require("@ccw-pwa-ui/Image");
var _Modal = require("@ccw-pwa-ui/Modal");
var _Input = require("@ccw-pwa-ui/Input");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Header = require("@ccw-pwa-ui/Header");
require("../styles/ForgotPasswordComponentStyle.css");
var _reactBootstrap = require("react-bootstrap");
var _Button = require("@ccw-pwa-ui/Button");
const ForgotPasswordComponent = props => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "forgot-password-screen"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "forgot-password-header-container"
  }, /*#__PURE__*/_react.default.createElement(_Header.Header, {
    imageUrl: props.headerPentairLogoFP,
    imageStyle: {
      width: '100%'
    }
  })), props.displayModalForgotPassword && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: props.displayModalForgotPassword,
    modalHeaderText: props.modalHeaderText,
    modalHeaderTextStyle: props.modalHeaderTextStyle,
    modalDetailText: props.modalDetailText,
    modalHeaderIcon: props.modalHeaderIcon,
    displayCrossIcon: props.displayCrossIcon,
    variant: props.variant,
    positiveActionButtonTitle: props.positiveActionButtonTitle,
    positiveAction: props.positiveAction,
    negativeButtonActionTitle: props.negativeButtonActionTitle,
    crossIconAction: props.crossIconAction,
    negativeAvtion: props.negativeAvtion
  })), props.displayUserNotExistModal && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: props.displayUserNotExistModal,
    modalHeaderText: props.modalHeaderText,
    modalHeaderTextStyle: props.modalHeaderTextStyle,
    modalDetailText: props.modalUserNotExistHeaderText,
    modalHeaderIcon: props.modalHeaderIcon,
    displayCrossIcon: props.displayCrossIcon,
    variant: props.variant,
    positiveActionButtonTitle: props.positiveActionButtonTitle,
    positiveAction: props.positiveActionUserNotExist
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: "welcome-user-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-scr"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "full-height"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-image-container welcome-scr-banner forgot-password-image"
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, {
    url: props.welcomeScreenImageFP
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "banner-text"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      color: '#FFFFFF',
      lineHeight: '1.2',
      marginBottom: '16px',
      fontWeight: 600
    },
    variant: "header-text",
    headerText: props.bannerHeaderTextFP
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      color: '#FFFFFF',
      lineHeight: '1.4',
      fontSize: 20,
      marginBottom: '16px',
      fontWeight: 400
    },
    variant: "header-text",
    headerText: props.bannerDetailTextFP
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "email-screen"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "wellcome-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-logo-container"
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, {
    url: props.pentair,
    imageStyle: {
      alignSelf: 'left'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "email-screen-title"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "link-text",
    headerText: props.forgotPasswordHeaderText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "email-input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "email-screen-detail"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "simple-text",
    headerText: props.forgotPasswordDetailText
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "forgot-password-container ".concat(!props.isEmailValid && props.isEmailTouched ? "invalid-email" : null)
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: "Email"
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputStyle: {
      borderRadius: 10
    },
    placeholder: props.emailPlaceholder,
    value: props.email,
    onchange: props.onChageEmail,
    onBlur: props.handleEmailBlurr
  }), !props.isEmailValid && props.isEmailTouched ? /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Please enter a valid email",
    variant: "simple-text",
    headerStyle: {
      fontSize: 12,
      fontWeight: 400,
      color: '#E00932',
      lineHeight: '22px'
    }
  }) : null, !props.isEmailValid && props.isEmailTouched && /*#__PURE__*/_react.default.createElement("img", {
    src: props.warningImage,
    className: "input-currentWarningIcon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "email-button-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "email-button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: props.buttonTitle,
    onClick: props.onClickForgotPassword,
    disabled: !props.isDisabled
  }))))))))), props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : null);
};
var _default = exports.default = ForgotPasswordComponent;